import { render, staticRenderFns } from "./TableHistoryWeb.vue?vue&type=template&id=7ae07596"
import script from "./TableHistoryWeb.vue?vue&type=script&setup=true&lang=js"
export * from "./TableHistoryWeb.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports